import React, { useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import CategoryItem from "./CategoryItem";
import ProcedurePopup from "./ProcedurePopup";

const gridVariants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { staggerChildren: 0.04 } },
};
const itemVariants = {
  hidden: { y: 6, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { duration: 0.18 } },
};

const CategoryGrid = ({
  categories,
  selectedCategory,
  onCategoryClick,
  onClosePopup,
  data,
  serviceLoading,
}) => {
  // Khóa cuộn nền khi popup mở
  useEffect(() => {
    if (selectedCategory) {
      const prev = document.body.style.overflow;
      document.body.style.overflow = "hidden";
      return () => (document.body.style.overflow = prev);
    }
  }, [selectedCategory]);

  return (
    <>
      <motion.div
        className="grid md:grid-cols-4 grid-cols-3 gap-2 lg:gap-4 p-3"
        variants={gridVariants}
        initial="hidden"
        animate="show"
      >
        {categories.map((category) => (
          <motion.div key={category.id} variants={itemVariants}>
            <CategoryItem
              name={category.name}
              image={category.image || "/images/document-logo.png"}
              onClick={() => onCategoryClick(category)}
            />
          </motion.div>
        ))}
      </motion.div>

      <AnimatePresence>
        {selectedCategory && (
          <ProcedurePopup
            serviceLoading={serviceLoading}
            data={data}
            category={selectedCategory}
            onClose={onClosePopup}
          />
        )}
      </AnimatePresence>
    </>
  );
};

export default CategoryGrid;
